module.exports = __webpack_public_path__ + "img/ludo7.6cb95643.jpg";